<template>
  <div v-if="isLoading" class="transition-loader">
    <div class="spinner"></div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useUiStore } from '@/stores'

const uiStore = useUiStore()
const isLoading = computed(() => uiStore.isPageLoading)
</script>

<style scoped>
.transition-loader {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  z-index: 9999;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.spinner {
  border: 2px solid transparent;
  border-top: 2px solid #409EFF;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
